export default {
  viewBox: "0 0 24 24",
  paths: [
    "M13 0L13 22L11 22L11 -8.74228e-08L13 0Z",
    "M6 17.3833L7.25423 16L12 21.2352L16.7458 16L18 17.3833L12 24L6 17.3833Z"
  ]
};